var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Boolean(_vm.phone))?_c('div',{staticClass:"service-provider-card-phone"},[_vm._v("\n    "+_vm._s(_vm.phone)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }